import { connect } from "react-redux";
import { productPickerSelector, productPickerActions } from "./product-picker-reducer";
import { profileSelector } from "../Profile/profile-reducer";
import { basketSelector, basketActions } from "ReactReducers/Basket/basket-reducer";

export function productPickerComposer(Component) {
    const mapStateToProps = function (state) {
        return {
            productPickerWork: productPickerSelector.work(state),
            productPickerProduct: productPickerSelector.productIndex(state),
            productPickerBasketProductConfig: productPickerSelector.basketProductConfig(state),
            amount: productPickerSelector.amount(state),
            salesConfigIndex: productPickerSelector.salesConfigIndex(state),
            periodValueIndex: productPickerSelector.periodValueIndex(state),
            primaryPrice: productPickerSelector.primaryPrice(state),
            secondaryPrice: productPickerSelector.secondaryPrice(state),
            classesValue: productPickerSelector.classesValue(state),
            isGettingProductPrice: productPickerSelector.isGettingProductPrice(state),
            isAdding: basketSelector.isAdding(state),
            basket: basketSelector.basket(state),
            loggedIn: profileSelector.loggedIn(state)
        };
    };

    const mapDispatchToProps = function (dispatch) {
        return {
            setWork: work => dispatch(productPickerActions.setWork(work)),
            setProductIndex: productIndex => dispatch(productPickerActions.setProductIndex(productIndex)),
            setAmount: quantity => dispatch(productPickerActions.setAmount(quantity)),
            setSalesConfigIndex: index => dispatch(productPickerActions.setSalesConfigIndex(index)),
            setPeriodValueIndex: index => dispatch(productPickerActions.setPeriodValueIndex(index)),
            setClassesValue: classesData => dispatch(productPickerActions.setClassesValue(classesData)),
            basketAdd: basketItem => dispatch(basketActions.basketAdd(basketItem))
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(Component);
}
